export default function($) {
  $(document).ready(function(){
  	$(window).scroll(function() {
			if ($(this).scrollTop()>30) {
				$('.icon-header-media').hide(200);
			} else {
				$('.icon-header-media').show(200);
			}
  	});

    $('.owl-carousel').owlCarousel({
	    loop:false,
	    margin:40,
	    nav:true,
	    slideBy: 3,
	    navText : ["<div class='dashicons dashicons-arrow-left-alt2'></div>","<div class='dashicons dashicons-arrow-right-alt2'></div>"],
	    responsive:{
	      0:{
	        items:1
	      },
	      640:{
	        items:2
	      },
	      960:{
	      	items:3
	      }
	    }
		});
  });
}
